import React from 'react'
import { Route } from 'react-router-dom'
import RoutesWrapper from '../RoutesWrapper'

const Stage1 = React.lazy(
  () => import('../../pages/stages/stage1/Stage1Main'),
)
const Stage1Story = React.lazy(
  () => import('../../pages/stages/stage1/Stage1Story'),
)
const Stage1Ending = React.lazy(
  () => import('../../pages/stages/stage1/Stage1Ending'),
)

const loc = `stage1`

export const Stage1Routes = (
  <>
    <Route
      path="/stage1"
      element={
        <RoutesWrapper loc={loc}>
          <Stage1 />
        </RoutesWrapper>
      }
    />
    <Route
      path="/stage1/story"
      element={
        <RoutesWrapper loc={loc}>
          <Stage1Story />
        </RoutesWrapper>
      }
    />
    <Route
      path="/stage1/ending"
      element={
        <RoutesWrapper loc={loc}>
          <Stage1Ending />
        </RoutesWrapper>
      }
    />
  </>
)
